// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"79cc08f6","213":"d545d048","238":"57c9b8a3","239":"b67fbdf4","488":"bb3fbfaf","622":"ca383a6b","749":"7d379e6b","830":"a35c7e3e","903":"9c070a09"}[chunkId] + ".chunk.js";
};